import { WindowPercentageArea } from '@nx-customer-apps/shared/enums';
import { EnumDictionary } from '../types';

export const windowPercentageAreaDictionary: EnumDictionary<WindowPercentageArea, number> = {
    [WindowPercentageArea.Small]: 0.1,
    [WindowPercentageArea.Medium]: 0.25,
    [WindowPercentageArea.Large]: 0.35
};
